import type { ReadonlyURLSearchParams } from "next/navigation";
import type { ViewType } from "../query/types";
import {
  coerceBlockConfigContainer,
  getActiveViewType,
} from "../shared/blockConfig";
import { searchParamsToLayoutState } from "./urlLayout";

export type PageDataLike = {
  blocks?: Array<{ default?: boolean; config?: unknown }>;
  modelId?: string;
  fields?: Array<{
    modelId: string;
    handle: string;
    definition?: { handle?: string | null } | null;
  }>;
};

export const resolveEffectiveListView = (args: {
  view?: ViewType;
  searchParams?: ReadonlyURLSearchParams;
  pageData?: PageDataLike | null;
}): ViewType | undefined => {
  if (args.view) {
    return args.view;
  }

  const layout = args.searchParams
    ? searchParamsToLayoutState(args.searchParams)
    : undefined;
  if (layout?.view) {
    return layout.view;
  }

  const block =
    args.pageData?.blocks?.find((entry) => entry.default) ??
    args.pageData?.blocks?.[0];
  if (!block?.config) {
    return undefined;
  }

  return getActiveViewType(coerceBlockConfigContainer(block.config));
};
